<template>
  <div class="flex p-1 md:p-1.5 rounded-full bg-grey-light-50 border border-grey-light-200 w-fit mt-2">
    <div
      v-for="product in products"
      :key="product.name"
      @click="switchProduct(product.name)"
      :class="[
        'flex items-center justify-center rounded-full py-1.5 px-4 md:py-2 md:px-6 cursor-pointer',
        shopsStore.currentProduct === product.name
          ? product.name === 'boost'
            ? 'bg-[#23D59F] shadow-sm'
            : product.name === 'plans'
              ? 'bg-blue-300 shadow-sm'
              : 'bg-brand-600 shadow-sm'
          : '',
      ]"
    >
      <div class="h-[24px] md:h-[30px] flex items-center justify-center">
        <img
          :class="product.name === 'layby' ? 'h-[16px] md:h-[20px] w-20 md:w-24' : 'h-[16px] md:h-[20px] w-16 md:w-20'"
          :src="shopsStore.currentProduct === product.name ? product.logoWhite : product.logoGrey"
          :alt="product.alt"
        />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import boostGrey from '@/assets/shopper/boost-logo-grey.svg';
import boostWhite from '@/assets/shopper/boost-logo-white.svg';
import laybyGrey from '@/assets/shopper/layby-logo-grey.svg';
import laybyWhite from '@/assets/shopper/layby-logo-white.svg';
import plansGrey from '@/assets/shopper/plans-logo-grey.svg';
import plansWhite from '@/assets/shopper/plans-logo-white.svg';
import { useShopsStore } from '@/stores/shops';

const shopsStore = useShopsStore();

const products = [
  { name: 'layby' as const, logoWhite: laybyWhite, logoGrey: laybyGrey, alt: 'LayUp Logo' },
  { name: 'plans' as const, logoWhite: plansWhite, logoGrey: plansGrey, alt: 'Plans Logo' },
  { name: 'boost' as const, logoWhite: boostWhite, logoGrey: boostGrey, alt: 'Boost Logo' },
];

const switchProduct = (product: 'layby' | 'plans' | 'boost') => {
  shopsStore.clearFilters();
  shopsStore.currentProduct = product;
};
</script>
